import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for casino reports.
 */
export default class tableInformeCasinoView extends JetView {
    /**
     * Configures the view layout and properties.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'treetable', // Treetable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            scheme: {
                $group: {
                    by: 'Punto', // Grouping by 'Punto' field
                },
            },
            bready: function () {
                this.openAll(); // Opens all groups in the tree table
            },
            footer: true, // Enables footer
            columns: [
                {
                    id: 'Fecha', // Column ID
                    header: 'Fecha', // Column header
                    width: 250, // Column width
                    template: function (obj, common) {
                        if (obj.$group)
                            // Check if the row is a group
                            return common.treetable(obj, common) + obj.value; // Return group template
                        return obj.Fecha; // Return date value
                    },
                    footer: 'Total:', // Footer content
                },
                { id: 'Moneda', header: _('Moneda'), width: 150 }, // Currency column
                {
                    id: 'CantidadJugadas', // Plays count column
                    header: _('Cantidad de Jugadas'), // Column header
                    footer: { content: 'summColumn' }, // Footer content for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200, // Column width
                },
                {
                    id: 'ValorApostado', // Bet value column
                    header: _('Valor Apostado'), // Column header
                    footer: { content: 'summColumn' }, // Footer content for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200, // Column width
                },
                {
                    id: 'ValorPremios', // Prizes value column
                    header: _('Valor Premios'), // Column header
                    footer: { content: 'summColumn' }, // Footer content for summation
                    format: webix.i18n.numberFormat, // Number formatting
                    width: 200, // Column width
                },
            ],
            autowidth: false, // Disable auto width
            data: [
                // Initial data for the table
                {
                    Fecha: '2018-12-26', // Date
                    Moneda: 'PEN', // Currency
                    CantidadJugadas: '86', // Plays count
                    ValorApostado: '20.00', // Bet value
                    ValorPremios: '0.00', // Prizes value
                },
                {
                    Fecha: '2018-02-26', // Date
                    Moneda: 'PEN', // Currency
                    CantidadTickets: '16', // Tickets count
                    ValorEntradasEfectivo: '20.00', // Cash entries value
                    ValorEntradasBonoTC: '0.00', // Bonus entries value
                    ValorEntradasTraslados: '0.00', // Transfers value
                    ValorEntradasRecargas: '0.00', // Reloads value
                    ValorSalidasEfectivo: '20.00	', // Cash exits value
                    ValorSalidasTraslados: '2.05	', // Transfers exits value
                    ValorSalidasNotasRetiro: '0.00', // Withdrawal notes value
                    Saldo: '162.00', // Balance
                    MMoneda: '168.15', // Another currency value
                    Punto: 'agilomartinez', // Point of sale
                },
                {
                    Fecha: '2018-11-26', // Date
                    Moneda: 'PEN', // Currency
                    CantidadTickets: '88', // Tickets count
                    ValorEntradasEfectivo: '10.00', // Cash entries value
                    ValorEntradasBonoTC: '0.00', // Bonus entries value
                    ValorEntradasTraslados: '0.00', // Transfers value
                    ValorEntradasRecargas: '0.00', // Reloads value
                    ValorSalidasEfectivo: '20.00	', // Cash exits value
                    ValorSalidasTraslados: '2.05	', // Transfers exits value
                    ValorSalidasNotasRetiro: '0.00', // Withdrawal notes value
                    Saldo: '62.00', // Balance
                    MMoneda: '868.15', // Another currency value
                    Punto: 'Abancay - Lima', // Point of sale
                },
            ],
            ready: function () {
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                }
            },
            math: true, // Enable math operations
            datafetch: 10, // Number of records to fetch
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        var url = grid.data.url; // URL for data loading
        grid.clearAll(); // Clear existing data

        // Event listener for filtering data
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0]; // Start date
                        string1 = string1 + '&dateTo=' + date[1]; // End date
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                // Load data for selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
